import { QueryClient } from '@tanstack/react-query'
import { QUERY_DEFAULTS } from '../constants/query'

export function createAppQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: QUERY_DEFAULTS,
    },
  })
}
